import { useQuery } from '@tanstack/react-query';
import { getProfile } from '../account.api';

/** Server-state for the profile extras (companyName) — TanStack Query, never Zustand. */
export function useProfile() {
  return useQuery({ queryKey: ['account', 'profile'], queryFn: getProfile });
}
